// Ask the backend to expose a schema in PostgREST (Supabase "Exposed schemas").
//
// The Management API token that does the work is a secret, so the browser only
// sends the schema name with the signed-in user's bearer; the backend
// (POST /api/admin/expose-schema/, backend/api/schema_exposure.py) writes the
// PostgREST config and waits until the schema is actually served.
//
// Resolves with the backend's result object in BOTH outcomes the backend can
// describe: { ok: true, ... } when the schema is served, and { ok: false, error,
// manual_fix } when it could not be exposed (HTTP 502). Throws only when the
// call itself failed: no session, 401/403, or a non-JSON answer.
import { getBackendURL } from "../components/env";
import { supabasePublic } from "../components/supabaseClient";

export async function exposeSchema(schemaName) {
  const { data: { session } = {} } = await supabasePublic().auth.getSession();
  const token = session?.access_token;
  if (!token) throw new Error("No active session — sign in again");

  const res = await fetch(`${getBackendURL()}/api/admin/expose-schema/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ schema: schemaName }),
  });
  const json = await res.json().catch(() => null);
  if (json && typeof json.ok === "boolean") return json;
  throw new Error((json && json.error) || `Expose schema failed (HTTP ${res.status})`);
}
